import React, { useEffect, useState } from "react";
import { Table, Tag, Space } from "antd";
import _ from "lodash";
import moment from "moment";
import { professionalService } from "../../../_services";
import { professionalAction } from "../../../_actions";


const data = [];

export const PreventiveInfomationTable = (props) => {
  const [tblData, SetTblData] = useState([]);
  const [districts, setDistricts] = useState([]);

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user"));
    professionalService.getDistrict(user.cityId).then((res) => {
      setDistricts(res.pc_districts);
    });
  }, []);

  const requiredKyes = [
    "chaptorCase",
    "chaptorCaseYear",
    "preventive_action",
    "date_from",
    "date_to",
    "chaptorCaseYear",
    "कारवाई करणारे पो.स्टे",
  ];

  console.log("districts", districts);
  const columns = [
    {
      title: "प्रतिबंधक कारवाही",
      dataIndex: "preventive_action",
      key: "preventive_action",
      render: (text, record) => (
        <Space size="middle">
          {record.preventive_action
            ? getPreventiveName(record && record.preventive_action)
            : ""}
        </Space>
      ),
    },
    {
      title: "चॅप्टर केस.नंबर",
      dataIndex: "chaptorCase",
      key: "chaptorCase",
    },
    {
      title: "चॅप्टर केस वर्ष",
      dataIndex: "chaptorCaseYear",
      key: "chaptorCaseYear",
    },
    {
      title: "कालावधी पासून",
      dataIndex: "date_from",
      key: "date_from",
      render: (text, record) => (
        <Space size="middle">
          {record.date_from ? getDateFormat(record.date_from) : "No Date"}
        </Space>
      ),
    },
    {
      title: "कालावधी पर्यंत",
      dataIndex: "date_to",
      key: "date_to",
      render: (text, record) => (
        <Space size="middle">
          {record.date_to ? getDateFormat(record.date_to) : "No Date"}
        </Space>
      ),
    },
    {
      title: "तडीपार क्षेत्र",
      dataIndex: "tadipar_unit",
      key: "tadipar_unit",
      render: (text, record) => (
        <Space size="middle">
          {
            record.tadipar_unit // ? getCityName(record && record.tadipar_unit) : ''
          }
        </Space>
      ),
    },
    {
      title: "कारवाई करणारे पो.स्टे",
      dataIndex: "action_taken_police_station",
      key: "action_taken_police_station",
      render: (text, record) => (
        <Space size="middle">{record?.action_taken_police_station}</Space>
      ),
    },
  ];

  // if (props.role === "2") {
  //   columns.push({
  //     title: "Action",
  //     key: "action",
  //     render: (text, record) => {
  //       const showAction = districts.some(
  //         (d) =>
  //           d.DistrictName === record.action_taken_police_station &&
  //           d.id === props.user.districtId
  //       );
  //       console.log("showAction", showAction); // true or false

  //       return (
  //         <Space size="middle">
  //           {showAction && <a onClick={() => gunhaFormEdit(record)}>Update</a>}

  //         </Space>
  //       );
  //     },
  //   });
  // }
  columns.push({
    title: "Action",
    key: "action",
    render: (text, record) => {
      const showAction = districts.some(
        (d) =>
          d.DistrictName === record.action_taken_police_station &&
          d.id === props.user.districtId
      );
      console.log("showAction", showAction); // true or false

      return (
        <Space size="middle">
          <a onClick={() => gunhaFormEdit(record)}>Update</a>
        </Space>
      );
    },
  });
  const [preventiveAction, setPreventiveAction] = useState([]);

  const getPreventiveData = () => {
    professionalAction.getPreventiveAction().then((res) => {
      res &&
        res.text().then((preventiveList) => {
          const data = [];
          preventiveList &&
            JSON.parse(preventiveList).data.forEach((item) => {
              data.push(item);
            });
          setPreventiveAction(data);
        });
    });
  };
  const getPreventiveName = (id) => {
    if (preventiveAction && preventiveAction.length > 0) {
      return (
        _.filter(preventiveAction, function (o) {
          return o.id === Number(id);
        })[0] &&
        _.filter(preventiveAction, function (o) {
          return o.id === Number(id);
        })[0].name
      );
    }
  };

  const getCityName = (id) => {
    const pc_cities = props.professionals.pc_cities;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === Number(id);
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === Number(id);
        })[0].City
      );
    }
  };

  // useEffect(() => {
  //   const { gunhaInfor } = props.professionals;
  //   if (gunhaInfor && gunhaInfor.length) {

  //   }
  // }, [props.isAccusedFormEdit && props.isAccusedFormEdit.idEdit]);

  useEffect(() => {
    getPreventiveData();
  }, []);

  useEffect(() => {
    let tempData = [];

    tempData =
      props.data &&
      props.data.map((res, index) => {
        return {
          ...res,
          key: index + 1,
          //preventive_action: getPreventiveName(res && res.preventive_action),
        };
      });
    SetTblData(tempData);
    // SetTblData
  }, [props.data]);

  const getDateFormat = (value) => {
    if (value) {
      return moment(value).format("MM-DD-YYYY");
    }
  };

  const gunhaFormEdit = (data) => {
    console.log("gunhaFormEdit", data);
    props.editPreventiveInfomation(
      data,
      _.findIndex(props.data, function (o) {
        return o.id == data.id;
      })
    );
  };
  const gunhaFormDelete = (data) => {
    props.deleteGhunhaInfomation(
      data,
      _.findIndex(props.data, function (o) {
        return o.id == data.id;
      })
    );
  };

  return <Table columns={columns} dataSource={tblData} />;
};
